<template>
    <PopupRouterView :showLeftIcon="true" label="Outgoing Check Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="outgoingcheck"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="outgoingCheckInput">


        <b-card header="Outgoing Check" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Outgoing Check Number" :model="model.outgoingCheckNumber" />
						<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction" size="sm" :model.sync="model.deliveryInstructionId"   :selected="model.deliveryInstruction != null ? model.deliveryInstruction.diNumber : ''" @input="getDeliveryInstructions" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstruction" />
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Process By" id="fieldset-process-by" size="sm" :model.sync="model.processByUserName"   :selected="model.processBy != null ? model.processBy.firstName : ''" @input="getUserInfos" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedProcessBy" />
						<app-input-datetimepicker id="fieldset-process-date" label-cols-lg="12"  label="Process Date" size="sm" :model.sync="model.processDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isUpdatable ="null"/>
						<app-input-combobox-autocomplete :options="outgoingCheckStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Outgoing Check Status" id="fieldset-outgoing-check-status" size="sm" :model.sync="model.outgoingCheckStatusId"   :selected="model.outgoingCheckStatus != null ? model.outgoingCheckStatus.name : ''" @input="getOutgoingCheckStatuss" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedOutgoingCheckStatus" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Outgoing Check Detail"
			:bordered="true" :items="outgoingCheckDetails" 
			:fields="fieldsOutgoingCheckDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByOutgoingCheckDetail" 
			:sort-desc.sync="sortDescOutgoingCheckDetail" small responsive	
			@editButtonMethod="editRowDataOutgoingCheckDetail"	
			@deleteButtonMethod="deleteRowDataOutgoingCheckDetail"	
			@showPopupAddMethod="addDataOutgoingCheckDetail()"	
			@showPopupUploadMethod="showPopupUploadOutgoingCheckDetail()"
			@downloadMethod="downloadOutgoingCheckDetail()"
			@addFromClipboardMethod="addFromClipboardOutgoingCheckDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardOutgoingCheckDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadOutgoingCheckDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowOutgoingCheckDetailFilter = !isShowOutgoingCheckDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowOutgoingCheckDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Name">
					<b-form-input id="input-outgoing-check-detail-name-table" v-model="filterOutgoingCheckDetail.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Delivery Instruction Detail">
					<v-select id="input-outgoing-check-detail-delivery-instruction-detail-table" append-to-body label="part" :options="deliveryInstructionDetails" :value="filterOutgoingCheckDetail.deliveryInstructionDetailId" :reduce="item => item.id" v-model="filterOutgoingCheckDetail.deliveryInstructionDetailId" @search="getDeliveryInstructionDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-outgoing-check-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterOutgoingCheckDetail.partId" :reduce="item => item.id" v-model="filterOutgoingCheckDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Qty">
					<b-form-input id="input-outgoing-check-detail-delivery-qty-table" v-model="filterOutgoingCheckDetail.deliveryQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Completed">
					<b-form-checkbox id="input-outgoing-check-detail-is-completed-table" class="float-right" v-model="filterOutgoingCheckDetail.isCompleted"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( outgoingCheckDetailPageSize * (currentOutgoingCheckDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(name)="row">
				<app-input-textbox :id="'input-outgoing-check-detail-name-' + row.index" label-cols-lg="12" label="Name" size="sm" :model.sync="row.item.name" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   @change="saveInputOutgoingCheckDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryInstructionDetail)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDetails" optionsLabel="part" optionsKey="id" :id="'input-outgoing-check-detail-delivery-instruction-detail-' + row.index" label-cols-lg="12" label="Delivery Instruction Detail" size="sm" :model.sync="row.item.deliveryInstructionDetailId"  @change="saveInputOutgoingCheckDetail(row.item)" :selected="row.item.deliveryInstructionDetail != null ? row.item.deliveryInstructionDetail.part : ''"  @input="getDeliveryInstructionDetails" :loading="isDeliveryInstructionDetailComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-outgoing-check-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputOutgoingCheckDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryQty)="row">
				<app-input-textbox :id="'input-outgoing-check-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputOutgoingCheckDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(isCompleted)="row">
				<app-input-checkbox :id="'input-outgoing-check-detail-is-completed-row-' + row.index" label-cols-lg="12" label="Is Completed" :model.sync="row.item.isCompleted" @change="saveInputOutgoingCheckDetail(row.item)" :isUpdatable ="null"  :nolabel="true"></app-input-checkbox>
			</template>

								
			<template v-slot:form-add-detail>
				<OutgoingCheckDetailInput 
					:model="modelOutgoingCheckDetail"
					:openPopup="isShowPopupOutgoingCheckDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataOutgoingCheckDetail"/>
			</template>
			<template v-slot:upload-detail>
					<OutgoingCheckDetailUpload
					:openPopup="isShowPopupUploadOutgoingCheckDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataOutgoingCheckDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentOutgoingCheckDetailPage"
				:total-rows="totalOutgoingCheckDetailRow"
				:per-page="outgoingCheckDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import OutgoingCheck from '@/models/OutgoingCheck/OutgoingCheck';
import OutgoingCheckList from '@/models/OutgoingCheck/OutgoingCheckList';
import OutgoingCheckFilter from '@/filters/OutgoingCheck/OutgoingCheckFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import OutgoingCheckStatus from '@/models/OutgoingCheckStatus/OutgoingCheckStatus';
import OutgoingCheckStatusFilter from '@/filters/OutgoingCheckStatus/OutgoingCheckStatusFilter';
import OutgoingCheckDetail from '@/models/OutgoingCheck/OutgoingCheckDetail';
import OutgoingCheckDetailFilter from '@/filters/OutgoingCheck/OutgoingCheckDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import OutgoingCheckDetailInput from '@/views/OutgoingCheck/OutgoingCheckDetailInput';
import OutgoingCheckDetailUpload from '@/views/OutgoingCheck/OutgoingCheckDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		AppInputCheckbox,
		OutgoingCheckDetailInput,OutgoingCheckDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsOutgoingCheckDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"name": { "class" : "th-name first-child", "label" : "Name", key: 'name', sortable: false}}, 
				{"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail', sortable: false}}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"isCompleted": { "class" : "th-is-completed d-stack-none", "label" : "Is Completed", key: 'isCompleted', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelOutgoingCheckDetail : {},
			isShowPopupOutgoingCheckDetail : false,
			isShowPopupUploadOutgoingCheckDetail : false,
			filterOutgoingCheck : null,
			currentOutgoingCheckPage : 1,
			outgoingCheckPageSize: 10,
			sortByOutgoingCheck: '',
			sortDescOutgoingCheck: '',
			filterOutgoingCheckDetail : null,
			currentOutgoingCheckDetailPage : 1,
			outgoingCheckDetailPageSize: 10,
			sortByOutgoingCheckDetail: '',
			sortDescOutgoingCheckDetail: '',
			sortingByOutgoingCheckDetail: [],
			outgoingCheckDetails : [],
			outgoingCheckDetailId : '',
			totalOutgoingCheckDetailRow : 0,
			isShowOutgoingCheckDetailFilter: false,
			isDownloadOutgoingCheckDetail: false,
			deliveryInstructionDetails: [],
			parts: [],
			deliveryInstructions: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			userInfos: [],
			processBys: [],
			isProcessByComboLoading: false,
			outgoingCheckStatuss: [],
			outgoingCheckStatuss: [],
			isOutgoingCheckStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryInstructionComboLoading: false,
			isUserInfoComboLoading: false,
			isOutgoingCheckStatusComboLoading: false,
			isOutgoingCheckComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPartComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getOutgoingCheck : async function(id) {
			this.isBusy = true;
			OutgoingCheck.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadOutgoingCheck = true;
			this.filterOutgoingCheck.id = this.modelId;
			OutgoingCheck.downloadDataDetail(this, this.filterOutgoingCheck).then(result => {
				this.isDownloadOutgoingCheck = false;
			}).catch(error => { this.isDownloadOutgoingCheck = false; })
		},
		getOutgoingCheckDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterOutgoingCheckDetail);
			if (this.modelId == null) return;
			filter.outgoingCheckId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByOutgoingCheckDetail != null) {
				this.sortingByOutgoingCheckDetail[this.sortByOutgoingCheckDetail] = this.sortDescOutgoingCheckDetail;
			}
			let currentPage = (this.currentOutgoingCheckDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalOutgoingCheckDetailRow + 1;
				let page = Math.ceil(totalData/this.outgoingCheckDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.outgoingCheckDetailPageSize = 0;
			// disable paging end
			OutgoingCheckDetail.getList(this, filter, this.sortingByOutgoingCheckDetail, currentPage , this.outgoingCheckDetailPageSize).then(result => {
				this.currentOutgoingCheckDetailPage = currentPage + 1;
				this.outgoingCheckDetails = result.data;
				this.totalOutgoingCheckDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getOutgoingChecks : async function(input) {
			let filter = new OutgoingCheckFilter();
			if (input != undefined) {
				filter.OutgoingCheckNumber = input;
			}
			this.isOutgoingCheckComboLoading = true;
			OutgoingCheck.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingChecks = result.data
				}
				this.isOutgoingCheckComboLoading = false;
			})
			.catch(error => {});
		},
		getOutgoingChecks : async function(input) {
			let filter = new OutgoingCheckFilter();
			if (input != undefined) {
				filter.outgoingCheckNumber = input;
			}
			this.isOutgoingCheckComboLoading = true;
			OutgoingCheck.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingChecks = result.data
				}
				this.isOutgoingCheckComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstruction(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessBy(item) {
			if(item == undefined || item == null) {
				this.model.processByUserName = null;
				this.model.processBy = null;
			} else {
				this.model.processByUserName = item.userName;
				this.model.processBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getOutgoingCheckStatuss : async function(input) {
			let filter = new OutgoingCheckStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			OutgoingCheckStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingCheckStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedOutgoingCheckStatus(item) {
			if(item == undefined || item == null) {
				this.model.outgoingCheckStatusId = null;
				this.model.outgoingCheckStatus = null;
			} else {
				this.model.outgoingCheckStatusId = item.id;
				this.model.outgoingCheckStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.outgoingCheckInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					OutgoingCheck.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'outgoingcheckindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					OutgoingCheck.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'outgoingcheckindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					OutgoingCheck.updateData(this, model, id)
					.catch((error) => {
						this.getOutgoingCheck(id);
					});
				}
			});
		},
		onHidden() {
			this.getOutgoingChecks();
		},
		addRowDataOutgoingCheckDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.outgoingCheckId =  this.modelId;
					OutgoingCheckDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getOutgoingCheckDetails(true);
						this.isShowPopupOutgoingCheckDetail = false;
					})
				} else {
					model.outgoingCheckId =  this.modelId;
					OutgoingCheckDetail.createDataDetail(this, model)
					.then(result => {
						this.getOutgoingCheckDetails(true);
						this.isShowPopupOutgoingCheckDetail = false;
					})
				}
			}
		},
		async editRowDataOutgoingCheckDetail(id) {
			this.outgoingCheckDetailId = id;
			this.isShowPopupOutgoingCheckDetail = true; 
		},
		async deleteRowDataOutgoingCheckDetail(id) {
			OutgoingCheckDetail.deleteData(this, id).then(result => { this.getOutgoingCheckDetails(); });
		},
		async resetDataOutgoingCheckDetail() {
			this.outgoingCheckDetailId = "";
			this.isShowPopupOutgoingCheckDetail = true;
		},
		async addDataOutgoingCheckDetail() {
			OutgoingCheckDetail.createData(this, { outgoingCheckId: this.modelId })
			.then(result => {
				this.getOutgoingCheckDetails(true);
			})
		},
		async addFromClipboardOutgoingCheckDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, outgoingCheckId: this.modelId });
				});
				OutgoingCheckDetail.addFromClipboard(this, names).then(result => { this.getOutgoingCheckDetails() });
			});
		},
		async replaceFromClipboardOutgoingCheckDetail() {
			let names = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					names.push({ name: item, outgoingCheckId: this.modelId });
				});
				OutgoingCheckDetail.replaceFromClipboard(this, names).then(result => { this.getOutgoingCheckDetails() });
			});   
		},
		showPopupUploadOutgoingCheckDetail() {
			if(this.outgoingCheckDetails != null && this.outgoingCheckDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap OutgoingCheckDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadOutgoingCheckDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadOutgoingCheckDetail = true;
			}
		},
		uploadDataOutgoingCheckDetail(modalEvent, newDatas) {
			this.isShowPopupUploadOutgoingCheckDetail = false; 
		},
		downloadOutgoingCheckDetail(modalEvent) {
			this.isDownloadOutgoingCheckDetail = true;
			this.filterOutgoingCheckDetail.outgoingCheckId = this.modelId;
			OutgoingCheckDetail.downloadDataDetail(this, this.filterOutgoingCheckDetail).then(result => {
				this.isDownloadOutgoingCheckDetail = false;
			}).catch(error => { this.isDownloadOutgoingCheckDetail = false; })
		},
		saveInputOutgoingCheckDetail(item) {
			if (this.outgoingChecks != null && this.outgoingChecks != undefined  && this.outgoingChecks.length > 0) {
				item.outgoingCheck = this.outgoingChecks.find(q => q.id == item.outgoingCheckId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					OutgoingCheckDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadOutgoingCheckDetail = false; 
			this.isShowPopupOutgoingCheckDetail = false; 
			if (modalType == 'OutgoingCheckDetail') {
				this.getOutgoingCheckDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowOutgoingCheckDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterOutgoingCheck = new OutgoingCheckFilter();
		this.filterOutgoingCheckDetail = new OutgoingCheckDetailFilter();
		//this.getOutgoingChecks();
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		//this.getDeliveryInstructions();
		//this.getUserInfos();
		//this.getOutgoingCheckStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getOutgoingCheck(id);
			} else {
				this.modelId = id;
				this.getOutgoingCheck(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByOutgoingCheckDetail : {
			handler: function() {
				this.getOutgoingCheckDetails();
			}
		},
		sortDescOutgoingCheckDetail: {
			handler: function() {
				this.getOutgoingCheckDetails();
			}
		},
		currentOutgoingCheckDetailPage: {
			handler: function() {
				this.getOutgoingCheckDetails();
			}
		},
		outgoingCheckDetailPageSize : {
			handler: function() {
				this.getOutgoingCheckDetails();
			}
		},
		filterOutgoingCheckDetail: {
			handler: function() {
				this.getOutgoingCheckDetails();
			},
			deep: true,
		},
	},
}
</script>
